import { qsa } from '@fluorescent/dom';

import { section } from '@/glow';
import { backgroundVideoHandler } from '@/lib/a11y';
import autoPlay from '@/lib/autoPlay';

const selectors = {
  video: '.video-hero__video',
};

section('video-hero', {
  videoHandler: null,

  onLoad() {
    import('animejs/lib/anime.es.js').then(({ default: anime }) => {
      const video = qsa(selectors.video, this.container);

      if (video.length) {
        this.videoHandler = backgroundVideoHandler(this.container);
        autoPlay(video);
      }

      // Animate the first slide only when it is scrolled into view
      const observer = new IntersectionObserver(
        ([{ intersectionRatio: visible }]) => {
          if (visible) {
            anime({
              targets: qsa('.animate', this.container),
              easing: 'easeOutQuart',
              translateY: [
                { value: 40, duration: 0 },
                { value: 0, duration: 500 },
              ],
              opacity: [
                { value: 0, duration: 0 },
                { value: 1, duration: 500 },
              ],
              delay: anime.stagger(150, { start: 800 }),
            });
            observer.disconnect();
          }
        }
      );

      observer.observe(this.container);
    });
  },

  onUnload() {
    this.videoHandler && this.videoHandler();
  },
});
